import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '../components/Header';
import { Sidebar } from '../components/layout/Sidebar';
export const ClientLayout = () => {
  // Mock data for sidebar - in real app, this would come from your state management
  const sidebarItems = [{
    id: '1',
    name: 'ADHD Research Space',
    type: 'space' as const,
    category: 'Research',
    isFavorite: true,
    lastAccessed: '2025-04-28T11:00:00Z'
  }, {
    id: '2',
    name: 'Customer Support Bot',
    type: 'chatbot' as const,
    category: 'Support',
    isFavorite: true,
    lastAccessed: '2025-04-28T10:30:00Z'
  }
  // ... more items
  ];
  return <div className="min-h-screen bg-surface flex flex-col" data-id="element-1611">
      <Header data-id="element-1612" />
      <div className="flex-1 flex" data-id="element-1613">
        <Sidebar items={sidebarItems} className="w-64 hidden lg:block shrink-0" onCreateSpace={() => {}} onCreateChatbot={() => {}} data-id="element-1614" />
        <main className="flex-1 overflow-x-hidden" data-id="element-1615">
          <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8" data-id="element-1616">
            <Outlet data-id="element-1617" />
          </div>
        </main>
      </div>
    </div>;
};